import React, { useState } from 'react';
import { DialogActions } from '@mui/material';
import CustomButton from '../../../../../../../../../../../../../lib/designSystem/Button';
import { useDispatch } from 'react-redux';
import CenteredCircularProgress from '../../../../../../../../../../../../../lib/designSystem/CircularProgress';
import CreditSimulator from '../../../../../create/components/Simulator';
import CustomAlert from '../../../../../../../../../../../../../lib/designSystem/Alert';
import { updateCreditRequestQuote } from '../../../../../../../../../../../../../lib/api/creditRequest';
import DialogActionsWrapper from '../../../../../../../../../Factoring/components/Recieved/components/ShoppingDialog/components/Summary/components/DialogActionWrapper';
import Summary from '../../../../../create/components/Simulator/components/Summary';
import CreditRequestStatus from '../../../../../../../common/CreditRequestStatus';

const ShoppingCartInTransfer = (props: any) => {
  const {
    setOpenShoppingCart,
    openRequest,
    setUp,
    setSuccessOpen,
    setFailureOpen,
    handleOpenDeleteConfirmModal,
  } = props;
  const [loading, setLoading] = useState(false);
  const [creditDetails, setCreditDetails] = useState<any>(openRequest);
  const [openWarning, setOpenWarning] = useState(false);
  const [editing, setEditing] = useState(false);
  const [amortizationSchedule, setAmortizationSchedule] = useState<any>(
    openRequest.documents,
  );

  const handleEdit = () => {
    setOpenWarning(true);
    setEditing(true);
  };

  if (loading) return <CenteredCircularProgress type="dialog" />;

  return (
    <div>
      <CreditRequestStatus openRequest={openRequest} audienceType="received" />
      <Summary
        creditDetails={creditDetails}
        amortizationSchedule={amortizationSchedule}
      />
      <DialogActions>
        <CustomButton
          color="secondary"
          onClick={() => setOpenShoppingCart(false)}
        >
          Cancelar
        </CustomButton>
      </DialogActions>
      <CustomAlert
        open={openWarning}
        setOpen={setOpenWarning}
        severity="warning"
        title="Atención"
        text="Si guardas los cambios, se borrarán todas las aprobaciones ya realizadas."
        handleClose={() => setOpenWarning(false)}
      />
    </div>
  );
};

export default ShoppingCartInTransfer;
